// src/pages/AuditLogs/index.tsx
// Main page component for Audit Logs Management

import React, { useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

// Components
import BreadCrumb from 'Components/Common/BreadCrumb';
import AuditLogsTable from './components/AuditLogsTable';
import AuditLogsFilters from './components/AuditLogsFilters';
import AuditLogsPagination from './components/AuditLogsPagination';

// Redux
import { fetchAuditLogs } from 'slices/auditLogs/thunk';
import { GetAuditLogsParams } from './types';

// Hooks
import { useBrandingTitle } from '../../hooks';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('audit_logs');

const AuditLogs: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  
  // Redux state
  const { data, loading, pagination, filters, sorting, error } = useSelector(
    (state: any) => state.AuditLogs
  );
  
  // Load data from API when filters/pagination/sorting change
  useEffect(() => {
    loadData();
  }, [filters, sorting, pagination.currentPage, pagination.pageSize]);
  
  // Show error toast if API call fails
  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);
  
    useBrandingTitle(st('nhat_ky_he_thong_text'));

  const loadData = () => {
    // Build API params from Redux state
    const params: GetAuditLogsParams = {
      pageIndex: pagination.currentPage,
      pageSize: pagination.pageSize,
      search: filters.searchTerm || undefined,
      actionType: filters.actionType,
      module: filters.module,
      result: filters.result,
      userId: filters.userId,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      ipAddress: filters.ipAddress,
      sortBy: sorting.field,
      sortOrder: sorting.order,
    };
    
    // Remove undefined values
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    ) as GetAuditLogsParams;
    
    // Dispatch thunk to fetch from API
    dispatch(fetchAuditLogs(cleanParams));
  };
  
  const handleDashboard = () => {
    navigate('/audit-logs/dashboard');
  };
  
  const handleExport = () => {
    // TODO: Implement export functionality
    toast.info('Export feature coming soon!');
  };
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumb */}
          <BreadCrumb 
            title={st('nhat_ky_he_thong_title')}
            pageTitle="Pages" 
          />
          
          <Row>
            <Col lg={12}>
                            <Card>
                <CardHeader>
                  {/* Filters với 2 nút actions */}
                  <AuditLogsFilters 
                    onDashboard={handleDashboard}
                    onExport={handleExport}
                  />
                </CardHeader>
                
                <CardBody>
                  
                  {/* Table */}
                  <AuditLogsTable
                    data={data}
                    loading={loading}
                    page={pagination.currentPage}
                    pageSize={pagination.pageSize}
                  />
                  
                  {/* Pagination */}
                  <AuditLogsPagination />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AuditLogs;